<template>
    <fixed-header :threshold="threshold" @change="updateFixedStatus">
        <div>
            <div class="header">
                <main-container>
                    <header-logo :small="sticky" />
                    <div class="menu-container">
                        <public-menu :menu="menuItems"></public-menu>
                    </div>
                </main-container>
            </div>
        </div>
    </fixed-header>
</template>
<script>
import FixedHeader from "vue-fixed-header";
import HeaderLogo from "src/components/header/private/HeaderLogo.vue";
import PublicMenu from "src/components/header/public/menu/Menu.vue";
import { Services } from "src/services/Services.js";

export default {
    components: {
        FixedHeader,
        HeaderLogo,
        PublicMenu,
    },
    data() {
        return {
            threshold: 110,
            sticky: false,
        };
    },
    methods: {
        updateFixedStatus(next) {
            this.threshold = next ? 60 : 110;
            this.sticky = next;
        },
    },
    asyncComputed: {
        async menuItems() {
            const body = await Services.wpApi.menuItems();
            return body.items;
        },
    },
};
</script>

<style lang="sass" scoped>
.vue-fixed-header
    .header
        padding: 0 10px
        display: flex
        border-bottom: 1px solid $color-secondary
        background: $color-white
        .main-container
            display: flex
            align-items: center
            justify-content: space-between
            width: 100%
            .menu-container
                width: 100%
                display: flex
                margin-left: 40px

.vue-fixed-header--isFixed
    .header
        position: fixed
        top: 0
        z-index: $header-z-index
        width: 100%
        animation: appear .15s ease-out
        height: 60px
        border-bottom: 0
        box-shadow: 0px 3px 6px rgba(0,0,0,0.16)

.header-mobile, .nav-mobile
        display: none

+r(1140)
    .vue-fixed-header .header, .vue-fixed-header--isFixed .header
        display: none

    .header-mobile
        padding: 12px 12px
        display: flex
        border-bottom: 1px solid rgba(176,177,166,0.6)
        background: $color-white

        .main-container
            width: 100%
            display: flex
            align-items: center
            justify-content: space-between

            .toolbar
                width: 100%
                display: flex
                flex-direction: row
                justify-content: flex-end

                .icon:first-child
                    margin: 0px 16px
                    cursor: pointer

                .icon:last-child
                    display: flex
                    align-items: center

                    img
                        width: 24px
                        max-width: 32px
                        max-height: 32px

    .nav-mobile
        display: block
        position: fixed
        top: 62px
        left: 0
        bottom: 0
        width: 100%
        padding: 30px 15px
        background-color: $color-white
        overflow-y: scroll
        overflow-x: hidden
        z-index: $header-z-index + 2

@keyframes appear
    0%
        transform: translateY(-110px)
    100%
        transform: translateY(0px)
</style>
